/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurveyRequest = {
    properties: {
        survey: {
    type: 'SatisfactionSurvey',
    isRequired: true,
},
        data: {
    type: 'array',
    contains: {
        type: 'SatisfactionSurveyData',
    },
    isRequired: true,
},
    },
};